import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, unref as _unref, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e1e7abba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-student-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit Student", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Edit Student", -1))
const _hoisted_5 = { class: "steps-indicator" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "step-number" }
const _hoisted_8 = { class: "step-label" }
const _hoisted_9 = { class: "form-step" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Personal Information", -1))
const _hoisted_12 = { class: "form-grid" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_15 = {
  key: 0,
  class: "error-message"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_18 = {
  key: 0,
  class: "error-message"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "birthday" }, "Birthday", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "Gender", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Gender", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "male" }, "Male", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "female" }, "Female", -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "weight" }, "Weight (lbs)", -1))
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ethnicity" }, "Ethnicity", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone", -1))
const _hoisted_33 = { class: "form-section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Address Information", -1))
const _hoisted_35 = { class: "form-grid" }
const _hoisted_36 = { class: "form-group full-width" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addressLine1" }, "Street Address", -1))
const _hoisted_38 = { class: "form-group full-width" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addressLine2" }, "Apt/Suite/Unit", -1))
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City", -1))
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select State", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "zip" }, "ZIP Code", -1))
const _hoisted_48 = { class: "form-section" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pickup Location", -1))
const _hoisted_50 = { class: "form-grid" }
const _hoisted_51 = { class: "form-group full-width" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pickupAddress" }, "Pickup Address", -1))
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pickupLat" }, "Pickup Latitude", -1))
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pickupLng" }, "Pickup Longitude", -1))
const _hoisted_57 = { class: "form-group full-width" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pickupNotes" }, "Pickup Notes", -1))
const _hoisted_59 = { class: "map-container" }
const _hoisted_60 = { class: "marker-popup" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Pickup Location", -1))
const _hoisted_62 = { class: "form-step" }
const _hoisted_63 = { class: "form-section" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "District Selection", -1))
const _hoisted_65 = { class: "district-search" }
const _hoisted_66 = {
  key: 0,
  class: "districts-list"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "district-info" }
const _hoisted_69 = { class: "form-section" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Selection", -1))
const _hoisted_71 = { class: "school-search" }
const _hoisted_72 = {
  key: 0,
  class: "schools-list"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "school-info" }
const _hoisted_75 = {
  key: 0,
  class: "school-select"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, "✓", -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = {
  key: 1,
  class: "no-results"
}
const _hoisted_79 = { class: "form-section" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Academic Information", -1))
const _hoisted_81 = { class: "form-grid" }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "grade" }, "Grade", -1))
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "level" }, "Level", -1))
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "studentType" }, "Student Type", -1))
const _hoisted_88 = { class: "form-step" }
const _hoisted_89 = { class: "form-section" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Student Needs", -1))
const _hoisted_91 = { class: "needs-container" }
const _hoisted_92 = { class: "needs-input" }
const _hoisted_93 = ["onKeydown"]
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { class: "common-needs" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Common Needs:", -1))
const _hoisted_97 = { class: "common-needs-list" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = {
  key: 0,
  class: "selected-needs"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Selected Needs:", -1))
const _hoisted_101 = { class: "needs-tags" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "form-section" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Additional Comments", -1))
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { class: "form-step" }
const _hoisted_107 = { class: "form-section" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Billing Records", -1))
const _hoisted_109 = { class: "billing-form" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Add New Billing Record", -1))
const _hoisted_111 = { class: "form-grid" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "billingStartDate" }, "Start Date", -1))
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "billingEndDate" }, "End Date", -1))
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "billingRate" }, "Rate ($)", -1))
const _hoisted_118 = { class: "form-group full-width" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "billingNotes" }, "Notes", -1))
const _hoisted_120 = ["disabled"]
const _hoisted_121 = {
  key: 0,
  class: "billing-records"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Current Billing Records", -1))
const _hoisted_123 = { class: "billing-list" }
const _hoisted_124 = { class: "billing-header" }
const _hoisted_125 = { class: "billing-info" }
const _hoisted_126 = { class: "billing-dates" }
const _hoisted_127 = { class: "billing-rate" }
const _hoisted_128 = { class: "billing-details" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = {
  key: 2,
  class: "billing-notes"
}
const _hoisted_132 = { class: "billing-actions" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = {
  key: 1,
  class: "no-records"
}
const _hoisted_137 = { class: "form-navigation" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "←", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "→", -1))
const _hoisted_140 = {
  key: 2,
  type: "submit",
  class: "submit-button"
}

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { API_URL } from "../config";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import type { LeafletMapRef } from "../types";

// Fix Leaflet's default marker path issues
interface LeafletIconDefaultPrototype {
  _getIconUrl?: string;
}

interface School {
  id: number;
  name: string;
  address: string;
  city?: string;
  state?: string;
  zipcode?: string;
  latitude?: number;
  longitude?: number;
  district?: District;
}

interface District {
  id: number;
  name: string;
  address?: string;
  city?: string;
  notes?: string;
}

enum Gender {
  Male = "male",
  Female = "female",
}

// Form state
interface BillingRecord {
  id?: number;
  startDate: string;
  endDate?: string;
  suspensionDate?: string;
  restartDate?: string;
  rate: number;
  notes?: string;
  isActive: boolean;
  suspensionReason?: string;
  terminationReason?: string;
  school: School;
  district: District;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditStudentView',
  setup(__props) {

delete (L.Icon.Default.prototype as LeafletIconDefaultPrototype)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Interfaces
const student = ref({
  firstName: "",
  lastName: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  birthday: "",
  gender: "" as Gender | "",
  weight: null as number | null,
  ethnicity: "",
  grade: "",
  level: "",
  studentType: "",
  comments: "",
  notes: "",
  needs: "",
  primarySchool: null as School | null,
  district: null as District | null,
  pickupLat: null as number | null,
  pickupLng: null as number | null,
  pickupAddress: null as string | null,
  pickupNotes: null as string | null,
});

// Form validation
const errors = ref({
  firstName: "",
  lastName: "",
});

// Steps configuration
const steps = [
  { number: 1, label: "Personal Info" },
  { number: 2, label: "School & District" },
  { number: 3, label: "Needs & Comments" },
  { number: 4, label: "Billing" },
];

const currentStep = ref(1);
const totalSteps = steps.length;

// Schools handling
const schools = ref<School[]>([]);
const schoolSearch = ref("");

// Needs handling
const needsArray = ref<string[]>([]);
const newNeed = ref("");
const commonNeeds = [
  "Special Education",
  "ESL Support",
  "Speech Therapy",
  "Physical Therapy",
  "Occupational Therapy",
  "Behavioral Support",
  "Academic Support",
  "Transportation",
  "Assistive Technology",
  "Medical Support",
];

// US States
const states = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

// Districts handling
const districts = ref<District[]>([]);
const districtSearch = ref("");

// Billing handling
const billingRecords = ref<BillingRecord[]>([]);
const newBillingRecord = ref<Partial<BillingRecord>>({
  startDate: new Date().toISOString().split("T")[0],
  rate: 0,
  isActive: true,
});

const route = useRoute();
const router = useRouter();

// Map reference
const map = ref<LeafletMapRef | null>(null);

// Computed properties
const filteredSchools = computed(() => {
  const searchTerm = schoolSearch.value.toLowerCase();
  return schools.value.filter(
    (school) =>
      school.name.toLowerCase().includes(searchTerm) ||
      school.address.toLowerCase().includes(searchTerm)
  );
});

const filteredDistricts = computed(() => {
  const searchTerm = districtSearch.value.toLowerCase();
  return districts.value.filter(
    (district) =>
      district.name.toLowerCase().includes(searchTerm) ||
      district.address?.toLowerCase().includes(searchTerm)
  );
});

const mapZoom = ref(12);
const mapCenter = ref<[number, number]>([41.7658, -72.6734]); // Default center (Hartford, CT)

const hasPickupLocation = computed(() => {
  return !!(student.value.pickupLat && student.value.pickupLng);
});

// Update map center when student address is loaded
const updateMapCenter = () => {
  if (student.value.lat && student.value.lng) {
    mapCenter.value = [student.value.lat, student.value.lng];
    if (map.value) {
      // Access the Leaflet map instance
      const leafletMap = map.value.leafletObject;
      if (leafletMap) {
        leafletMap.setView(mapCenter.value, mapZoom.value);
      }
    }
  }
};

// Methods
const validateField = (field: string) => {
  errors.value[field] = "";
  if (field === "firstName" && !student.value.firstName.trim()) {
    errors.value.firstName = "First name is required";
  }
  if (field === "lastName" && !student.value.lastName.trim()) {
    errors.value.lastName = "Last name is required";
  }
};

const validateStep = () => {
  if (currentStep.value === 1) {
    validateField("firstName");
    validateField("lastName");
    return !errors.value.firstName && !errors.value.lastName;
  }
  return true;
};

const goToStep = (step: number) => {
  if (step < currentStep.value || validateStep()) {
    currentStep.value = step;
  }
};

const nextStep = () => {
  if (validateStep() && currentStep.value < totalSteps) {
    currentStep.value++;
  }
};

const previousStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
};

const selectSchool = (school: School) => {
  student.value.primarySchool = school;
};

const addNeed = () => {
  const trimmedNeed = newNeed.value.trim();
  if (trimmedNeed && !needsArray.value.includes(trimmedNeed)) {
    needsArray.value.push(trimmedNeed);
  }
  newNeed.value = "";
};

const toggleCommonNeed = (need: string) => {
  const index = needsArray.value.indexOf(need);
  if (index === -1) {
    needsArray.value.push(need);
  } else {
    needsArray.value.splice(index, 1);
  }
};

const removeNeed = (index: number) => {
  needsArray.value.splice(index, 1);
};

const selectDistrict = (district: District) => {
  student.value.district = district;
};

const fetchSchools = async () => {
  try {
    const response = await fetch(`${API_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      schools.value = await response.json();
    }
  } catch (error) {
    console.error("Error fetching schools:", error);
  }
};

const fetchDistricts = async () => {
  try {
    const response = await fetch(`${API_URL}/districts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      districts.value = await response.json();
    }
  } catch (error) {
    console.error("Error fetching districts:", error);
  }
};

const fetchStudent = async () => {
  try {
    const response = await fetch(`${API_URL}/students/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      student.value = { ...data };
      if (data.primarySchool) {
        student.value.primarySchool = data.primarySchool;
      }
      needsArray.value = data.needs
        ? data.needs.split(",").map((need: string) => need.trim())
        : [];
      // Update map center after loading student data
      updateMapCenter();
    }
  } catch (error) {
    console.error("Error fetching student:", error);
  }
};

const fetchBillingRecords = async () => {
  try {
    const response = await fetch(
      `${API_URL}/billing/student/${route.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    if (response.ok) {
      billingRecords.value = await response.json();
    }
  } catch (error) {
    console.error("Error fetching billing records:", error);
  }
};

const canAddBilling = computed(() => {
  return (
    newBillingRecord.value.startDate &&
    newBillingRecord.value.rate &&
    student.value.primarySchool &&
    student.value.district
  );
});

const addBillingRecord = async () => {
  try {
    const response = await fetch(`${API_URL}/billing`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        ...newBillingRecord.value,
        studentId: route.params.id,
        schoolId: student.value.primarySchool?.id,
        districtId: student.value.district?.id,
      }),
    });

    if (response.ok) {
      await fetchBillingRecords();
      // Reset form
      newBillingRecord.value = {
        startDate: new Date().toISOString().split("T")[0],
        rate: 0,
        isActive: true,
      };
    }
  } catch (error) {
    console.error("Error adding billing record:", error);
  }
};

const suspendBilling = async (record: BillingRecord) => {
  try {
    const suspensionDate = new Date().toISOString().split("T")[0];
    const suspensionReason = prompt("Please enter reason for suspension:");

    if (suspensionReason) {
      const response = await fetch(`${API_URL}/billing/${record.id}/suspend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ suspensionDate, suspensionReason }),
      });

      if (response.ok) {
        await fetchBillingRecords();
      }
    }
  } catch (error) {
    console.error("Error suspending billing:", error);
  }
};

const restartBilling = async (record: BillingRecord) => {
  try {
    const restartDate = new Date().toISOString().split("T")[0];

    const response = await fetch(`${API_URL}/billing/${record.id}/restart`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ restartDate }),
    });

    if (response.ok) {
      await fetchBillingRecords();
    }
  } catch (error) {
    console.error("Error restarting billing:", error);
  }
};

const endBilling = async (record: BillingRecord) => {
  try {
    const endDate = new Date().toISOString().split("T")[0];
    const terminationReason = prompt("Please enter reason for termination:");

    if (terminationReason) {
      const response = await fetch(`${API_URL}/billing/${record.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          endDate,
          terminationReason,
          isActive: false,
        }),
      });

      if (response.ok) {
        await fetchBillingRecords();
      }
    }
  } catch (error) {
    console.error("Error ending billing:", error);
  }
};

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString();
};

const getBillingStatus = (record: BillingRecord) => {
  if (!record.isActive) {
    return record.suspensionDate ? "SUSPENDED" : "TERMINATED";
  }
  return "ACTIVE";
};

const submitForm = async () => {
  if (!validateStep()) return;

  try {
    student.value.needs = needsArray.value.join(", ");
    const response = await fetch(`${API_URL}/students/${route.params.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(student.value),
    });

    if (response.ok) {
      router.push("/students");
    } else {
      const error = await response.json();
      alert(`Error: ${error.message}`);
    }
  } catch (error) {
    console.error("Error updating student:", error);
    alert("An error occurred while updating the student.");
  }
};

const handleMapClick = (event: { latlng: { lat: number; lng: number } }) => {
  const { lat, lng } = event.latlng;
  student.value.pickupLat = lat;
  student.value.pickupLng = lng;

  // Reverse geocode to get address
  reverseGeocode(lat, lng);

  // Update the marker position
  if (map.value) {
    const leafletMap = map.value.leafletObject;
    if (leafletMap) {
      leafletMap.setView([lat, lng], mapZoom.value);
    }
  }
};

const useHomeAddress = async () => {
  if (student.value.addressLine1) {
    const address = `${student.value.addressLine1}, ${student.value.city}, ${student.value.state} ${student.value.zip}`;
    const coords = await geocode(address);
    if (coords) {
      student.value.pickupLat = coords.lat;
      student.value.pickupLng = coords.lng;
      student.value.pickupAddress = student.value.addressLine1;
      if (map.value) {
        const leafletMap = map.value.leafletObject;
        if (leafletMap) {
          leafletMap.setView([coords.lat, coords.lng], mapZoom.value);
        }
      }
    }
  }
};

const clearPickupLocation = () => {
  student.value.pickupLat = undefined;
  student.value.pickupLng = undefined;
  student.value.pickupAddress = "";
  student.value.pickupNotes = "";

  // Reset map view to home address if available
  if (student.value.lat && student.value.lng) {
    if (map.value) {
      const leafletMap = map.value.leafletObject;
      if (leafletMap) {
        leafletMap.setView(
          [student.value.lat, student.value.lng],
          mapZoom.value
        );
      }
    }
  }
};

const geocode = async (address: string) => {
  try {
    const response = await fetch(
      `${API_URL}/geocode?address=${encodeURIComponent(address)}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.error("Geocoding error:", error);
  }
  return null;
};

const reverseGeocode = async (lat: number, lng: number) => {
  try {
    const response = await fetch(
      `${API_URL}/geocode/reverse?lat=${lat}&lng=${lng}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    if (response.ok) {
      const result = await response.json();
      student.value.pickupAddress = result.address;
    }
  } catch (error) {
    console.error("Reverse geocoding error:", error);
  }
};

onMounted(() => {
  fetchSchools();
  fetchDistricts();
  if (route.params.id) {
    fetchStudent();
    fetchBillingRecords();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/students" }, {
        default: _withCtx(() => [
          _createTextVNode("Students")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
        return _createElementVNode("div", {
          key: step.number,
          class: _normalizeClass(["step", {
          active: currentStep.value === step.number,
          completed: currentStep.value > step.number,
        }]),
          onClick: ($event: any) => (goToStep(step.number))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(step.number), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(step.label), 1)
        ], 10, _hoisted_6)
      }), 64))
    ]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      class: "edit-form"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((student.value.firstName) = $event)),
                id: "firstName",
                class: _normalizeClass({ error: errors.value.firstName }),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (validateField('firstName')))
              }, null, 34), [
                [_vModelText, student.value.firstName]
              ]),
              (errors.value.firstName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors.value.firstName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((student.value.lastName) = $event)),
                id: "lastName",
                class: _normalizeClass({ error: errors.value.lastName }),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (validateField('lastName')))
              }, null, 34), [
                [_vModelText, student.value.lastName]
              ]),
              (errors.value.lastName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.value.lastName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((student.value.birthday) = $event)),
                id: "birthday",
                type: "date"
              }, null, 512), [
                [_vModelText, student.value.birthday]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((student.value.gender) = $event)),
                id: "gender"
              }, _hoisted_26, 512), [
                [_vModelSelect, student.value.gender]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((student.value.weight) = $event)),
                id: "weight",
                type: "number",
                min: "0"
              }, null, 512), [
                [
                  _vModelText,
                  student.value.weight,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((student.value.ethnicity) = $event)),
                id: "ethnicity"
              }, null, 512), [
                [_vModelText, student.value.ethnicity]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((student.value.phone) = $event)),
                id: "phone",
                type: "tel"
              }, null, 512), [
                [_vModelText, student.value.phone]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((student.value.addressLine1) = $event)),
                id: "addressLine1"
              }, null, 512), [
                [_vModelText, student.value.addressLine1]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((student.value.addressLine2) = $event)),
                id: "addressLine2"
              }, null, 512), [
                [_vModelText, student.value.addressLine2]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((student.value.city) = $event)),
                id: "city"
              }, null, 512), [
                [_vModelText, student.value.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((student.value.state) = $event)),
                id: "state"
              }, [
                _hoisted_44,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                  return _createElementVNode("option", {
                    key: state,
                    value: state
                  }, _toDisplayString(state), 9, _hoisted_45)
                }), 64))
              ], 512), [
                [_vModelSelect, student.value.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((student.value.zip) = $event)),
                id: "zip",
                pattern: "[0-9]*",
                maxlength: "5"
              }, null, 512), [
                [_vModelText, student.value.zip]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((student.value.pickupAddress) = $event)),
                id: "pickupAddress",
                placeholder: "Enter pickup address or use map below"
              }, null, 512), [
                [_vModelText, student.value.pickupAddress]
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((student.value.pickupLat) = $event)),
                id: "pickupLat",
                type: "number",
                step: "0.0000001",
                placeholder: "Click map or enter latitude"
              }, null, 512), [
                [_vModelText, student.value.pickupLat]
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((student.value.pickupLng) = $event)),
                id: "pickupLng",
                type: "number",
                step: "0.0000001",
                placeholder: "Click map or enter longitude"
              }, null, 512), [
                [_vModelText, student.value.pickupLng]
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((student.value.pickupNotes) = $event)),
                id: "pickupNotes",
                placeholder: "Add any notes about the pickup location"
              }, null, 512), [
                [_vModelText, student.value.pickupNotes]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_unref(LMap), {
              ref_key: "map",
              ref: map,
              zoom: mapZoom.value,
              "onUpdate:zoom": _cache[18] || (_cache[18] = ($event: any) => ((mapZoom).value = $event)),
              center: mapCenter.value,
              "use-global-leaflet": false,
              onClick: handleMapClick
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LTileLayer), {
                  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                  "layer-type": "base",
                  name: "OpenStreetMap"
                }),
                (hasPickupLocation.value)
                  ? (_openBlock(), _createBlock(_unref(LMarker), {
                      key: 0,
                      "lat-lng": [
                  student.value.pickupLat || mapCenter.value[0],
                  student.value.pickupLng || mapCenter.value[1],
                ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LPopup), null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _createElementVNode("p", null, _toDisplayString(student.value.pickupAddress || "No address set"), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["lat-lng"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["zoom", "center"]),
            _createElementVNode("div", { class: "map-controls" }, [
              _createElementVNode("button", {
                type: "button",
                class: "secondary-button",
                onClick: useHomeAddress
              }, " Use Home Address "),
              _createElementVNode("button", {
                type: "button",
                class: "secondary-button",
                onClick: clearPickupLocation
              }, " Clear Location ")
            ])
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((districtSearch).value = $event)),
              placeholder: "Search districts...",
              class: "search-input"
            }, null, 512), [
              [_vModelText, districtSearch.value]
            ]),
            (filteredDistricts.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDistricts.value, (district) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: district.id,
                      class: _normalizeClass(["district-item", { selected: district.id === student.value.district?.id }]),
                      onClick: ($event: any) => (selectDistrict(district))
                    }, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("h4", null, _toDisplayString(district.name), 1),
                        _createElementVNode("p", null, _toDisplayString(district.address), 1)
                      ])
                    ], 10, _hoisted_67))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((schoolSearch).value = $event)),
              placeholder: "Search schools by name or address...",
              class: "search-input"
            }, null, 512), [
              [_vModelText, schoolSearch.value]
            ]),
            (filteredSchools.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSchools.value, (school) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: school.id,
                      class: _normalizeClass(["school-item", { selected: school.id === student.value.primarySchool?.id }]),
                      onClick: ($event: any) => (selectSchool(school))
                    }, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("h4", null, _toDisplayString(school.name), 1),
                        _createElementVNode("p", null, _toDisplayString(school.address), 1)
                      ]),
                      (school.id === student.value.primarySchool?.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_73))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_78, " No schools found matching your search "))
          ])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _hoisted_83,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((student.value.grade) = $event)),
                id: "grade"
              }, null, 512), [
                [_vModelText, student.value.grade]
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((student.value.level) = $event)),
                id: "level"
              }, null, 512), [
                [_vModelText, student.value.level]
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((student.value.studentType) = $event)),
                id: "studentType"
              }, null, 512), [
                [_vModelText, student.value.studentType]
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((newNeed).value = $event)),
                onKeydown: _withKeys(_withModifiers(addNeed, ["prevent"]), ["enter"]),
                placeholder: "Type a need and press Enter",
                class: "need-input"
              }, null, 40, _hoisted_93), [
                [_vModelText, newNeed.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: addNeed,
                class: "add-need-btn",
                disabled: !newNeed.value.trim()
              }, " Add ", 8, _hoisted_94)
            ]),
            _createElementVNode("div", _hoisted_95, [
              _hoisted_96,
              _createElementVNode("div", _hoisted_97, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(commonNeeds, (need) => {
                  return _createElementVNode("button", {
                    key: need,
                    type: "button",
                    class: _normalizeClass(["common-need-btn", { selected: needsArray.value.includes(need) }]),
                    onClick: ($event: any) => (toggleCommonNeed(need))
                  }, _toDisplayString(need), 11, _hoisted_98)
                }), 64))
              ])
            ]),
            (needsArray.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  _hoisted_100,
                  _createElementVNode("div", _hoisted_101, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(needsArray.value, (need, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "need-tag"
                      }, [
                        _createTextVNode(_toDisplayString(need) + " ", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "remove-need",
                          onClick: ($event: any) => (removeNeed(index))
                        }, " × ", 8, _hoisted_102)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_103, [
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((student.value.comments) = $event)),
              rows: "4",
              placeholder: "Add any additional notes or comments about the student..."
            }, null, 512), [
              [_vModelText, student.value.comments]
            ])
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 3]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _hoisted_108,
          _createElementVNode("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((newBillingRecord.value.startDate) = $event)),
                  id: "billingStartDate",
                  type: "date",
                  required: ""
                }, null, 512), [
                  [_vModelText, newBillingRecord.value.startDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((newBillingRecord.value.endDate) = $event)),
                  id: "billingEndDate",
                  type: "date"
                }, null, 512), [
                  [_vModelText, newBillingRecord.value.endDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _hoisted_117,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((newBillingRecord.value.rate) = $event)),
                  id: "billingRate",
                  type: "number",
                  step: "0.01",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    newBillingRecord.value.rate,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _hoisted_119,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((newBillingRecord.value.notes) = $event)),
                  id: "billingNotes",
                  placeholder: "Add any billing notes..."
                }, null, 512), [
                  [_vModelText, newBillingRecord.value.notes]
                ])
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "primary-button",
              onClick: addBillingRecord,
              disabled: !canAddBilling.value
            }, " Add Billing Record ", 8, _hoisted_120)
          ]),
          (billingRecords.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                _hoisted_122,
                _createElementVNode("div", _hoisted_123, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingRecords.value, (record) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: record.id,
                      class: _normalizeClass(["billing-item", { inactive: !record.isActive }])
                    }, [
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("span", _hoisted_126, _toDisplayString(formatDate(record.startDate)) + " - " + _toDisplayString(record.endDate ? formatDate(record.endDate) : "Ongoing"), 1),
                          _createElementVNode("span", _hoisted_127, "$" + _toDisplayString(record.rate) + "/day", 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["billing-status", { suspended: record.suspensionDate }])
                        }, _toDisplayString(getBillingStatus(record)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        (record.school)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_129, "School: " + _toDisplayString(record.school.name), 1))
                          : _createCommentVNode("", true),
                        (record.district)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_130, " District: " + _toDisplayString(record.district.name), 1))
                          : _createCommentVNode("", true),
                        (record.notes)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_131, _toDisplayString(record.notes), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_132, [
                        (record.isActive && !record.suspensionDate)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (suspendBilling(record)),
                              class: "warning-button"
                            }, " Suspend ", 8, _hoisted_133))
                          : _createCommentVNode("", true),
                        (!record.isActive && record.suspensionDate)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (restartBilling(record)),
                              class: "success-button"
                            }, " Restart ", 8, _hoisted_134))
                          : _createCommentVNode("", true),
                        (record.isActive)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: ($event: any) => (endBilling(record)),
                              class: "danger-button"
                            }, " End ", 8, _hoisted_135))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_136, "No billing records found"))
        ])
      ], 512), [
        [_vShow, currentStep.value === 4]
      ]),
      _createElementVNode("div", _hoisted_137, [
        (currentStep.value > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: previousStep,
              class: "secondary-button"
            }, [
              _hoisted_138,
              _createTextVNode(" Previous ")
            ]))
          : _createCommentVNode("", true),
        (currentStep.value < _unref(totalSteps))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: nextStep,
              class: "primary-button"
            }, [
              _createTextVNode(" Next "),
              _hoisted_139
            ]))
          : _createCommentVNode("", true),
        (currentStep.value === _unref(totalSteps))
          ? (_openBlock(), _createElementBlock("button", _hoisted_140, " Update Student "))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}
}

})